import {
	useTranslationCapChart,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useContext } from 'react';
import { CapExportMenu } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChartPageHeader/CapExportMenu.tsx';
import { CapPageHeader } from '@dealstack/frontend/app/pages/Project/Cap/common/CapPageHeader/CapPageHeader.tsx';
import { CapChartPageContext } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChartPage.tsx';
import { CapChartSettings } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChartSettings/CapChartSettings.tsx';
import { PermissionWrapper } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';
import { ResourceType } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions.ts';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string.ts';
import { PermissionRole } from '@dealstack/shared/lib/generated';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Text, Tooltip } from '@mantine/core';
import { TitleRailToggle } from '@dealstack/frontend/app/pages/Project/Cap/common/TitleRailToggle/TitleRailToggle.tsx';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

export const CapChartPageHeader = () => {
	const tCapChart = useTranslationCapChart();
	const tCommonUi = useTranslationCommonUi();
	const {
		downloadAs,
		downloadLoading,
		dealId,
		dealName,
		isFundDeal,
		isMasterView,
		setIsMasterView,
		rail,
		setRail,
		hasNomineeStructure,
	} = useContext(CapChartPageContext).capChartData;

	return (
		<CapPageHeader title={tCapChart('title')}>
			{hasNomineeStructure && <TitleRailToggle rail={rail} setRail={setRail} />}

			{isFundDeal && setIsMasterView && (
				<Tooltip label="View aggregated data across all portfolio deals">
					<AdvancedSwitch
						rightText={
							<Text data-testid={TEST_ELEMENT_IDS.FUND_MASTER_VIEW_TOGGLE_LABEL}>
								{tCommonUi('master_view')}
							</Text>
						}
						selectedValue={isMasterView}
						onChange={(value) => setIsMasterView(value === true)}
						selectedColor="dark.8"
						unselectedColor="dark.8"
						dataTestId={TEST_ELEMENT_IDS.FUND_MASTER_VIEW_TOGGLE}
					/>
				</Tooltip>
			)}

			<PermissionWrapper
				resourceType={ResourceType.DEAL}
				resourceId={defaultToEmptyString(dealId)}
				permissionRole={PermissionRole.EXPORT_VIEWER}
			>
				<CapExportMenu
					options={[
						{
							label: tCapChart('header.export_menu.download_as_png'),
							isLoading: downloadLoading,
							onClick: () => downloadAs('png', dealName),
							dataTestId:
								TEST_ELEMENT_IDS.CAP_TABLE_GROUP_STRUCTURE_CHART_DOWNLOAD_PNG_BUTTON,
						},
						{
							label: tCapChart('header.export_menu.download_as_jpg'),
							isLoading: downloadLoading,
							onClick: () => downloadAs('jpg', dealName),
						},
					]}
				></CapExportMenu>
			</PermissionWrapper>
			<CapChartSettings />
		</CapPageHeader>
	);
};
